import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { REGEX_PATTERNS } from '../../../../../auth/config/constants';
import { Messages } from '../../../../../auth/config/messages';
import { Isupport } from '../../../../../auth/models/IUser';
import { AuthService } from '../../../../../auth/services/auth.service';
import { HasRBACPermissionDirective } from '../../../../../core/directives/rbac-permission.directive';
import { canHasPermission } from '../../../../../core/helpers/permission-formate-helper';
import { StorageService } from '../../../../../core/helpers/storage.service';
import { Storagekeys } from '../../../../../core/model/storage';
import { AlertService } from '../../../../../core/services/alert.service';
import {
  LoggerService,
  LogLevel,
} from '../../../../../core/services/logger.service';
import { HelperPerm } from '../../../../services/tenant-helper';
import { OnboardingService } from '../services/onboarding.service';

@Component({
  selector: 'app-get-in-touch',
  templateUrl: './get-in-touch.component.html',
  styleUrl: './get-in-touch.component.scss',
  standalone: true,
  imports: [
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatButtonModule,
    ReactiveFormsModule,
    CommonModule,
    MatProgressSpinnerModule,
    MatMenuModule,
    MatTooltipModule,
    HasRBACPermissionDirective,
  ],
})
export class GetInTouchComponent implements OnInit {
  userSupportForm!: FormGroup;
  toggleEmail: boolean = false;
  toggleCall: boolean = false;
  isHelpAccesible: boolean = false;
  lastName: string = '';
  isLoading = false;
  permission = HelperPerm;
  private readonly router = inject(Router);

  constructor(
    private readonly supportSurvice: OnboardingService,
    private readonly alertService: AlertService,
    private readonly authService: AuthService,
    private readonly logger: LoggerService,
    private readonly storageService: StorageService
  ) {}

  ngOnInit(): void {
    this.initializeForm();
    this.authService.RbacPermissions$?.subscribe(permissions => {
      this.isHelpAccesible = !canHasPermission(
        this.permission.view,
        permissions
      );
    });
  }

  initializeForm() {
    const firstName =
      this.storageService.getItem(Storagekeys.firstName, true) ?? '';
    this.lastName =
      this.storageService.getItem(Storagekeys.lastName, true) ?? '';
    const email = this.storageService.getItem(Storagekeys.email, true) ?? '';

    this.userSupportForm = new FormGroup({
      firstName: new FormControl(firstName, [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(40),
        Validators.pattern(REGEX_PATTERNS.CUSTOM_NAME_PATTERN),
      ]),
      lastName: new FormControl(this.lastName, [
        Validators.minLength(3),
        Validators.maxLength(40),
        Validators.pattern(REGEX_PATTERNS.CUSTOM_NAME_PATTERN),
      ]),
      email: new FormControl(email, [
        Validators.required,
        Validators.pattern(REGEX_PATTERNS.EMAIL),
      ]),
      contact: new FormControl('', [
        Validators.minLength(10),
        Validators.maxLength(10),
        Validators.pattern(REGEX_PATTERNS.ALLOW_NUMBERS_PATTERN),
      ]),
      subject: new FormControl('', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(200),
        Validators.pattern(REGEX_PATTERNS.CHANNEL_ROUTE),
      ]),
      message: new FormControl('', [
        Validators.minLength(3),
        Validators.maxLength(200),
      ]),
    });
  }

  get f(): { [key: string]: AbstractControl } {
    return this.userSupportForm?.controls;
  }

  submitForm() {
    if (this.userSupportForm.invalid) return;
    const request: Isupport = {
      first_Name: this.f['firstName'].value,
      last_Name: this.f['lastName'].value,
      email_Address: this.f['email'].value,
      mobile_Number: String(this.f['contact'].value ?? ''),
      subject: this.f['subject'].value,
      message: this.f['message'].value,
    };
    this.isLoading = true;
    this.supportSurvice.saveSupportForm(request).subscribe({
      next: response => {
        if (response) {
          this.isLoading = false;
          this.toggleEmailPopup();
          this.alertService.showAlert(
            Messages.Support_Success_Message,
            'success'
          );
        }
      },
      error: error => {
        this.isLoading = false;
        this.logger.log(LogLevel.ERROR, error);
        this.resetForm();
        this.alertService.showAlert(
          Messages.Support_Failed_Messages,
          'warning'
        );
      },
    });
  }

  toggleEmailPopup() {
    this.resetForm();
    this.toggleEmail = !this.toggleEmail;
    this.toggleCall = false;
  }

  toggleCallPopup() {
    this.toggleEmail = false;
    this.toggleCall = !this.toggleCall;
  }

  resetForm() {
    this.f['lastName'].setValue(this.lastName ?? '');
    this.f['message'].setValue('');
    this.f['subject'].setValue('');
    this.f['contact'].setValue('');
  }
  goToHelpTopics() {
    this.router.navigate(['help-topics'], {
      queryParams: {
        tab: 0,
      },
    });
  }
}
